module.exports = __webpack_public_path__ + "img/Taiwan-5.3dbf0946.jpg";